export default __webpack_public_path__ + "static/media/AmandaBaroni_02.af73ad50.jpg";